let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9BQCx")).then(() => parcelRequire('j6zKP'));